import React from 'react';
import { GET_COMPLETED_RECEIVED_REFERRALS } from '../gql';
import { REFERRAL_RECEIVER_SUBSCRIPTION } from '../../referral/gql/Subscription';
import { Stack } from '@mui/material';
import DateTimeUtils from '../../common/services/DateTimeUtils';
import { MyTypography } from '../../common/components';
import CompletedReferrals from './common/CompletedReferrals';
import ActiveReferralActionsCell from '../tables/components/ActiveReferralActionsCell';
import { referralIsOrderColumnItem } from '../tables/CommonReferralTable';

const columns = [
  {
    field: 'patient',
    headerName: 'Patient Name',
    width: 180,
    valueGetter: params => {
      return params.row.referral.getFullName();
    },
  },
  {
    field: 'mrn',
    headerName: 'Sending Clinic MRN',
    width: 150,
    valueGetter: params => {
      return params.row.referral.getMrn();
    },
  },
  {
    field: 'dob',
    headerName: 'Date of Birth',
    width: 150,
    valueGetter: params => {
      return params.row.referral.getPatientDob();
    },
  },
  {
    field: 'diagnosis',
    headerName: 'Diagnosis',
    width: 180,
    valueGetter: params => {
      return params.row.referral.getDiagnosis();
    },
  },
  {
    field: 'referrer',
    headerName: 'Referral Source',
    width: 320,
    valueGetter: params => {
      const clinic = params.row.referral.getReferrerClinic();
      const provider = params.row.referrer_provider?.display_name || '';
      if (!provider && !clinic) return '';
      return `Clinic: ${clinic || 'N/A'} | Provider: ${provider || 'N/A'}`;
    },
    renderCell: params => {
      const clinic = params.row.referral.getReferrerClinic();
      const provider = params.row.referrer_provider?.display_name || '';
      return (
        <Stack direction="column" spacing={1}>
          <MyTypography variant="subtitle1" component="p" color="text.primary" style={{ margin: 0 }}>
            Clinic: {clinic || 'N/A'}
          </MyTypography>
          <MyTypography variant="subtitle1" component="p" color="text.primary" style={{ margin: 0 }}>
            Provider: {provider || 'N/A'}
          </MyTypography>
          {clinic.includes('★') ? (
            <MyTypography variant="h6" component="h6" color="text.primary" style={{ fontStyle: 'italic', margin: 0 }}>
              {clinic !== '★ Referral From Fax' ? 'Submitted via Public Form' : ''}
            </MyTypography>
          ) : null}
        </Stack>
      );
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    headerAlign: 'center',
    sortable: false,
    editable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'center',
    renderCell: (params) => <ActiveReferralActionsCell row={params.row} type="received" completed={true}/>
  },
  {
    field: 'appointment_maintained',
    headerName: 'Maintained Appointment',
    width: 200,
    valueGetter: params => {
      return params.row.referral.isMaintainedAppointment();
    },
    renderCell: (params) => (
      <div style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      }} title={params.value}>
        {params.value}
      </div>
    ),
  },
  {
    field: 'appointments',
    headerName: 'Appointment Date',
    width: 200,
    valueGetter: params => {
      return params.row.referral.getDateOrReason();
    },
  },
  {
    field: 'accepted_at',
    headerName: 'Date Received',
    width: 250,
    valueGetter: params => {
      return params.row.referral.receivedFormattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
  referralIsOrderColumnItem,
  {
    field: 'updated_by',
    headerName: 'Last Updated By',
    width: 250,
    valueGetter: params => {
      return params.row.referral.getLastUpdatedByFullName();
    },
  },
  {
    field: 'updated_at',
    headerName: 'Last Updated At',
    width: 250,
    valueGetter: params => {
      return params.row.referral.formattedDate();
    },
    sortComparator: DateTimeUtils.dateSortComparator
  },
];

export default function CompletedReceivedReferrals({ uuid, onViewLogs, onView }) {
  return (
    <CompletedReferrals
      query={GET_COMPLETED_RECEIVED_REFERRALS}
      uuid={uuid}
      subscription={REFERRAL_RECEIVER_SUBSCRIPTION}
      onViewLogs={onViewLogs}
      onView={onView}
      columns={columns}
      showAppointmentFilter={false}
    />
  );
}
